function hasAside() {
    if($('.section-main__wrapper .section-main__aside').length > 0) {
        $('.section-main__wrapper').addClass('active');
    }
    else {
        $('.section-main__wrapper').removeClass('active');
    }
}